import { isUndefinedOrNull } from '../../TypeHelpers';
import where from './where';
export default function first(iterable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        iterable = where(iterable, predicate);
    }
    for (const item of iterable) {
        return item;
    }
    throw new Error("The collection is empty!");
}
